import { render, staticRenderFns } from "./CreateSGClusters.vue?vue&type=template&id=2b42711d&scoped=true"
import script from "./CreateSGClusters.vue?vue&type=script&lang=js"
export * from "./CreateSGClusters.vue?vue&type=script&lang=js"
import style0 from "./CreateSGClusters.vue?vue&type=style&index=0&id=2b42711d&prod&scoped=true&lang=css"
import style1 from "./CreateSGClusters.vue?vue&type=style&index=1&id=2b42711d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42711d",
  null
  
)

export default component.exports